import React from 'react';
import './About.css';
import './Bubbles.css';

const translations = {
  ar: {
    title: 'من نحن',
    description: 'MatchUp هو أول تطبيق سوري متخصص في حجز الملاعب الرياضية. نسعى لتسهيل عملية حجز الملاعب وتوفير تجربة سلسة وآمنة للاعبين وأصحاب الملاعب على حد سواء.',
    mission: 'مهمتنا',
    missionText: 'نهدف إلى ربط اللاعبين بأفضل الملاعب في سوريا وتوفير منصة موثوقة وسهلة الاستخدام لحجز الملاعب الرياضية.',
    vision: 'رؤيتنا',
    visionText: 'أن نكون المنصة الرائدة في سوريا والمنطقة لحجز الملاعب الرياضية وتنظيم الفعاليات الرياضية.',
  },
  en: {
    title: 'About Us',
    description: 'MatchUp is the first Syrian app specialized in booking sports stadiums. We strive to facilitate the stadium booking process and provide a smooth and secure experience for both players and stadium owners.',
    mission: 'Our Mission',
    missionText: 'We aim to connect players with the best stadiums in Syria and provide a reliable and easy-to-use platform for booking sports stadiums.',
    vision: 'Our Vision',
    visionText: 'To be the leading platform in Syria and the region for booking sports stadiums and organizing sports events.',
  }
};

function About({ language }) {
  const t = translations[language];

  return (
    <section id="about" className="about">
      <div className="bubble bubble-1"></div>
      <div className="bubble bubble-3"></div>
      <div className="bubble bubble-5"></div>
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2>{t.title}</h2>
        </div>
        <div className="about-content">
          <div className="about-main" data-aos="fade-up" data-aos-delay="100">
            <p className="about-description">{t.description}</p>
          </div>
          <div className="about-cards">
            <div className="about-card" data-aos="fade-right" data-aos-delay="200">
              <div className="card-icon">🎯</div>
              <h3>{t.mission}</h3>
              <p>{t.missionText}</p>
            </div>
            <div className="about-card" data-aos="fade-left" data-aos-delay="300">
              <div className="card-icon">🚀</div>
              <h3>{t.vision}</h3>
              <p>{t.visionText}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
